import React, { type ButtonHTMLAttributes } from 'react';
import Button from './Button';

interface DeleteButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    disabled?: boolean;
    showText?: boolean;
    isLoading?: boolean;
    text?: string;
}

/**
 * A standardized delete button component with a trash icon
 * Used to maintain consistent delete button styling across the application
 */
const DeleteButton: React.FC<DeleteButtonProps> = ({
    size = 'md',
    className = '',
    disabled = false,
    showText = false,
    isLoading = false,
    text = 'Remove',
    ...rest
}) => {
    return (
        <Button
            className={`flex items-center ${className}`}
            disabled={disabled}
            isLoading={isLoading}
            size={size}
            variant="destructive"
            {...rest}
        >
            <svg
                className={`w-4 h-4 ${showText ? 'mr-1' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            </svg>
            {showText && text}
        </Button>
    );
};

export default DeleteButton;
